import "./styles.css";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import Coin from "./pages/Coin";
import { makeStyles } from "@material-ui/core";
import Alert from "./components/Alert";

const useStyles = makeStyles(() => ({
  App: {
    backgroundColor: "#14161a",
    color: "#fff",
    minHeight: "100vh"
  }
}));

export default function App() {
  const classes = useStyles();

  return (
    <Router>
      <div className={classes.App}>
        <Header />
        <Route path="/" exact component={Home} />
        <Route path="/coins/:id" exact component={Coin} />
      </div>
      <Alert />
    </Router>
  );
}
